import { parseISO, isBefore, isAfter, isValid } from 'date-fns'
import { campoInvalido, campoObrigatorio } from 'helpers/Constantes/Mensagens'
export const dataLancamentoInvalida = 'A data de Previsão de Lançamento não pode ser inferior à nenhum outro campo de data.'
export const dataCompraInvalida = 'A data de Compra não pode ser superior à nenhum outro campo de data.'

export type DadosDatas = {
  compra: Date
  alvaraAprovacao: Date
  alvaraExecucao: Date
  registroEscritura: Date
  previsaoRi: Date
  previsaoLancamento: Date
  valido: boolean
}

export const dadosDatasValorDefault = {
  compra: null,
  alvaraAprovacao: null,
  alvaraExecucao: null,
  registroEscritura: null,
  previsaoRi: null,
  previsaoLancamento: null
} as unknown as DadosDatas

export class ValidacaoDadosDatas {
  compra: string
  alvaraAprovacao: string
  alvaraExecucao: string
  registroEscritura: string
  previsaoRi: string
  previsaoLancamento: string

  constructor(compra = '', alvaraAprovacao = '', alvaraExecucao = '', registroEscritura = '', previsaoRi = '', previsaoLancamento = '') {
    this.compra = compra
    this.alvaraAprovacao = alvaraAprovacao
    this.alvaraExecucao = alvaraExecucao
    this.registroEscritura = registroEscritura
    this.previsaoRi = previsaoRi
    this.previsaoLancamento = previsaoLancamento
  }

  validarInputUsuario(valor: Date): string {
    let error = ''

    if (valor === null) {
      error = campoObrigatorio
    } else if (valor < parseISO('1900-01-01 00:00:00') || !isValid(valor)) {
      error = campoInvalido
    }

    return error
  }

  validarDataCompra(datas: DadosDatas) {
    const listaDatas = [datas.alvaraAprovacao, datas.alvaraExecucao, datas.previsaoLancamento, datas.previsaoRi, datas.registroEscritura]
    if (!listaDatas.every((element) => isBefore(datas.compra, element))) return dataCompraInvalida

    return ''
  }

  validarPrevisaoLancamento(datas: DadosDatas) {
    const listaDatas = [datas.alvaraAprovacao, datas.alvaraExecucao, datas.compra, datas.previsaoRi, datas.registroEscritura]

    if (!listaDatas.every((element) => isAfter(datas.previsaoLancamento, element))) return dataLancamentoInvalida
    return ''
  }

  validarTodosCampos(state: DadosDatas): boolean {
    if (
      state.compra != null &&
      this.compra === '' &&
      state.alvaraAprovacao != null &&
      this.alvaraAprovacao === '' &&
      state.alvaraExecucao != null &&
      this.alvaraExecucao === '' &&
      state.registroEscritura != null &&
      this.registroEscritura === '' &&
      state.previsaoRi != null &&
      this.previsaoRi === '' &&
      state.previsaoLancamento != null &&
      this.previsaoLancamento === ''
    ) {
      return true
    }
    return false
  }
}
